import PropTypes from 'prop-types';
import React, { Component } from 'react';
import moment from 'moment';
import { Input } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import { Monedas } from '../../Monedas/Monedas/constants.js'
import { formatCurrency } from '../../../functions/functions';
import { getMonedas } from "../../../api/apicalls.js";


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            titulo: "",
            loteo_id: null,
            proveedor_id: null,
            proveedor:null,
            monedas: [], // Todas las Monedas de la api
            moneda: null, // Moneda para el Input (object)
            monto: "",
            fechaContrato: moment(),
            archivoContrato: null,
            archivoContratoInicial: null,
            cambiarArchivo: false,
            descripcion: "",
            postVariables: ['titulo', 'loteo_id', 'proveedor_id', 'monto', 'archivoContrato', 'descripcion'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    async componentDidMount() {
        const monedas = await getMonedas();
        const monedaPesos = monedas
            ? monedas.find(moneda => moneda.id === Monedas.PESOS)
            : null;

        this.setState({ 
            monedas,
            moneda: monedaPesos,
        });
    }

    findMoneda = (monedaId) => {
        const { monedas } = this.state

        const moneda = monedas
            ? monedas.find(moneda => moneda.id === monedaId)
            : null;

        return moneda
    }

    getMonedaSimbolo = () => {
        const { moneda } = this.state
        return moneda ? moneda.simbolo : ""
    }

    resetForm() {
        const monedaPesos = this.findMoneda(Monedas.PESOS);

        this.setState({
            id: null,
            titulo: "",
            loteo_id: null,
            proveedor_id: null,
            moneda: monedaPesos,
            monto: "",
            fechaContrato: moment(),
            archivoContrato: null,
            archivoContratoInicial: null,
            cambiarArchivo: false,
            descripcion: "",
            errors: [],
        });
    }

    getData() {
        const { 
            fechaContrato,
            postVariables,
            moneda,
        } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        const monedaId = moneda ? moneda.id : null;

        data.moneda = monedaId; 
        data.fechaContrato = fechaContrato ? fechaContrato.format('YYYY-MM-DD') : null;
        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                titulo: data.titulo,
                loteo_id: data.loteo.id,
                proveedor_id: data.proveedor.id,
                proveedor: data.proveedor,
                moneda: data.moneda,
                monto: data.monto,
                fechaContrato: moment(data.fechaContrato),
                archivoContrato: null,
                archivoContratoInicial: data.archivoContratoHash,
                descripcion: data.descripcion,
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Obra",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "La Obra ha sido creada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Obra",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Obra ha sido editada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Obra",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Obra",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "La Obra ha sido eliminada con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    onLoteoChange = (loteo) => {
        // Se setean tanto el loteo como su moneda preferida.
        // (Nota) La moneda tiene que poder cambiarse, la del loteo es solo
        // un default.
        const loteoId = loteo ? loteo.id : null;
        const monedaPreferida = loteo && loteo.moneda_preferida
            ? loteo.moneda_preferida
            : this.findMoneda(Monedas.PESOS);
        this.onChangeField('loteo_id', loteoId)
        this.onChangeField('moneda', monedaPreferida)
    }

    onMonedaChange = (moneda) => {
        this.onChangeField('moneda', moneda)
    }

    render() {
        let vars = this.modalVars();
        const { action } = this.props;
        const {
            archivoContratoInicial,
            proveedor,
            moneda,
        } = this.state;
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];

        if (action === 'EDIT') {
            vars['disabled'] = proveedor ? proveedor.debaja : false;
        }

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.obras.obras : null)}
                submitUrl={(vars.submitType ? api.obras.obras : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}

                className="ui-paradigma-modal ui-paradigma-modal-wide"
                fileUploader
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Datos principales</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            disabled={vars.disabled}
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            maxLength={50}
                            label={"Título"}
                            value={this.state.titulo}
                            onChange={(e) => this.onChangeField('titulo', e.target.value)}
                            error={() => this.getError('titulo')}
                        />

                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Fecha Contrato"}
                            inputComponent={
                                <ParadigmaDatePicker
                                    disabled={vars.disabled}
                                    value={this.state.fechaContrato}
                                    onChange={data => this.onChangeField('fechaContrato', data)}
                                />
                            }
                            error={() => this.getError('fechaContrato')}
                        />

                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Loteo"}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    disabled={vars.disabled}
                                    url={api.loteos.loteos_select}
                                    value={this.state.loteo_id}
                                    parameters={{
                                        paginationEnabled:false,
                                    }}
                                    onChange={this.onLoteoChange}
                                />
                            }
                            error={() => this.getError('loteo')}
                        />

                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Proveedor"}
                            inputComponent={
                                action !== 'DETAIL' ?
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    disabled={vars.disabled}
                                    url={api.proveedores.proveedores_select}
                                    parameters={{
                                        paginationEnabled:false,
                                    }}
                                    value={this.state.proveedor_id}
                                    onChange={(data) => this.onChangeField('proveedor_id', (data ? data.id : null))}
                                /> :
                                <p className="ui-inline-message">
                                    { this.state.proveedor ? this.state.proveedor.nombre : '' }
                                </p>
                            }
                            error={() => this.getError('proveedor')}
                        />
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Contrato</p>
                    <div className="ui-form-grid">
                        {
                            (action === 'EDIT') &&
                            <div className="ui-span-2">
                                <label className={'ui-checkbox-field' + (vars.disabled ? ' is-disabled' : '')}>
                                    <span>Cambiar archivo contrato</span>
                                    <input
                                        type="checkbox"
                                        checked={this.state.cambiarArchivo}
                                        disabled={vars.disabled}
                                        onChange={e => this.setState({ cambiarArchivo: e.target.checked, archivoContrato: null })}
                                    />
                                </label>
                            </div>
                        }

                        {
                            (action === 'CREATE') &&
                            <div className="ui-span-2">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Archivo Contrato"}
                                    error={() => this.getError('archivoContrato')}
                                    inputComponent={
                                        <Input
                                            className="ui-file-input"
                                            onChange={(e) => this.onChangeField('archivoContrato', e.target.files[0])}
                                            type="file"
                                            disabled={vars.disabled}
                                        />
                                    }
                                />
                            </div>

                        }
                        {
                            (action === 'DETAIL' || action === 'DELETE') && (typeof archivoContratoInicial === 'string') &&
                            <div className="ui-span-2">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Archivo Contrato"}
                                    inputComponent={
                                        <a
                                            className="ui-table-link"
                                            href={archivoContratoInicial ? (api.obras.contrato.replace('$obra_id', this.props.id()) + '?hash=' + archivoContratoInicial) : null}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Descargar contrato
                                        </a>
                                    }
                                />
                            </div>
                        }
                        {
                            (action === 'EDIT') &&
                            <div className="ui-span-2">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    error={() => this.getError('archivoContrato')}
                                    label={"Archivo Contrato"}
                                    inputComponent={
                                        this.state.cambiarArchivo ?
                                        <Input
                                            className="ui-file-input"
                                            onChange={(e) => this.onChangeField('archivoContrato', e.target.files[0])}
                                            type="file"
                                            disabled={vars.disabled}
                                        /> :
                                            (typeof archivoContratoInicial === 'string') ?
                                            <a
                                                className="ui-table-link"
                                                href={archivoContratoInicial ? (api.obras.contrato.replace('$obra_id', this.props.id()) + '?hash=' + archivoContratoInicial) : null}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Descargar contrato
                                            </a> :
                                            <p className="ui-inline-message">Sin archivo</p>
                                    }
                                />
                            </div>
                        }
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Detalle</p>
                    <div className="ui-form-grid">
                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                type={'textarea'}
                                rows={5}
                                label={"Descripción"}
                                value={this.state.descripcion}
                                onChange={(e) => this.onChangeField('descripcion', e.target.value)}
                                error={() => this.getError('descripcion')}
                            />
                        </div>
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Importe</p>
                    <div className="ui-money-grid">
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Monto"}
                            error={() => this.getError('monto')}
                            inputComponent={
                                <ParadigmaCurrencyInput
                                    disabled={vars.disabled}
                                    className="form-control monto w-100"
                                    symbol={this.getMonedaSimbolo()}
                                    value={formatCurrency(this.state.monto)}
                                    onChange={data => this.onChangeField('monto', data)}
                                />
                            }
                        />
                    </div>
                </section>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Obras/Obras/Modal.js